// extracted by mini-css-extract-plugin
export var checkbox = "_8b-0";
export var circle = "_8b-3";
export var horizontalContainer = "_8b-7";
export var sm = "_8b-5";
export var switch0 = "_8b-2";
export var switchDisabled = "_8b-8";
export var switchEnabled = "_8b-1";
export var textSwitchContainer = "_8b-9";
export var textSwitchOption = "_8b-a";
export var textSwitchOptionSelected = "_8b-b";
export var verticalContainer = "_8b-6";
export var xs = "_8b-4";